module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: แก้ไข Drone Model","page.description":"แก้ไขข้อมูลทั่วไปของ Drone Model รุ่น {name}","update_model.success":"ทำการแก้ไข Drone รุ่น {name} ในระบบเรียบร้อย","update_model.confirm.title":"ยืนยันแก้ไขข้อมูล Drone Model","update_model.confirm.message":"คุณต้องการแก้ไขข้อมูลของ Drone Model นี้ ?"}}')
  delete Component.options._Ctor
}
